module.exports = __webpack_public_path__ + "img/franchising_side-vector_right.70641970.svg";